import { useQuery } from 'react-query';
import { taxonService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useMenus = () => {
  return useQuery(
    `${ServerStateKeysEnum.menus}`,
    () => {
      return taxonService.getMenu();
    },
    { staleTime: Infinity }
  );
};
